/** SLOC Updation — the desk's list, desk and handheld moves together. */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { SlocListPage } from "@/features/warehouse/components/sloc-list-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

const search = z.object({
  tab: z.enum(["open", "done", "cancelled"]).default("done"),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
  /** The form a submit came from: the list offers a way straight back to it. */
  back: z.enum(["lot", "subbin"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/warehouse/$stage/sloc/")({
  validateSearch: search,
  beforeLoad: ({ params }) => guardDesk(params.stage, undefined, "sloc"),
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <SlocListPage
      stage={asStage(stage)}
      facilityId={useDeskFacility()}
      search={s}
      onSearch={(next) =>
        // Any change but the page's own starts again at page 1.
        void navigate({ search: (prev) => ({ ...prev, page: 1, ...next }) })
      }
    />
  );
}
